/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MAT_DRAWER_CONTAINER as ɵangular_material_src_material_sidenav_sidenav_a} from './drawer';